import * as THREE from 'three';
import { EventBus, GameEvents } from '@/core/EventBus';

/**
 * WebGL renderer setup and management
 */
export class Renderer {
  public renderer: THREE.WebGLRenderer;
  public scene: THREE.Scene;
  private canvas: HTMLCanvasElement;
  private eventBus: EventBus;

  constructor(canvas: HTMLCanvasElement, eventBus: EventBus) {
    this.canvas = canvas;
    this.eventBus = eventBus;

    // Create scene
    this.scene = new THREE.Scene();

    // Create renderer with transparency to show CSS background
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      alpha: true,
    });

    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.outputColorSpace = THREE.SRGBColorSpace;

    this.updateSize();
    this.setupResizeHandler();
  }

  private setupResizeHandler(): void {
    this.eventBus.on(GameEvents.WINDOW_RESIZED, () => {
      this.updateSize();
    });
  }

  /**
   * Update renderer size to match window
   */
  updateSize(): void {
    const width = window.innerWidth;
    const height = window.innerHeight;

    console.log('Renderer size:', width, 'x', height);
    this.renderer.setSize(width, height);
  }

  /**
   * Render the scene with the given camera
   */
  render(camera: THREE.Camera): void {
    this.renderer.render(this.scene, camera);
  }

  /**
   * Get the DOM element
   */
  get domElement(): HTMLCanvasElement {
    return this.renderer.domElement;
  }

  /**
   * Clean up resources
   */
  dispose(): void {
    this.renderer.dispose();
  }
}
